import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { stopLenis, startLenis } from "@/lib/lenis";

export default function Modal({ open, onClose, title, children, wide = false, testid = "modal" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    stopLenis();
    return () => {
      document.removeEventListener("keydown", onKey);
      startLenis();
    };
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center sm:p-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div
            className="absolute inset-0 bg-night/70 backdrop-blur-sm"
            onClick={onClose}
            data-testid={`${testid}-backdrop`}
          />
          <motion.div
            data-testid={testid}
            role="dialog"
            aria-modal="true"
            initial={{ y: 60, opacity: 0, scale: 0.98 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 40, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className={`relative w-full ${wide ? "max-w-2xl" : "max-w-lg"} bg-sand rounded-t-3xl sm:rounded-3xl shadow-2xl max-h-[92vh] overflow-y-auto overscroll-contain`}
            data-lenis-prevent
            style={{ WebkitOverflowScrolling: "touch" }}
          >
            <div className="sticky top-0 z-10 flex items-center justify-between px-6 sm:px-8 py-5 bg-sand/90 backdrop-blur border-b border-terracotta/15">
              <h3 className="font-serif text-2xl text-ink">{title}</h3>
              <button
                data-testid={`${testid}-close-btn`}
                onClick={onClose}
                className="p-2 rounded-full hover:bg-black/5 transition-colors"
                aria-label="Close dialog"
              >
                <X size={20} />
              </button>
            </div>
            <div className="px-6 sm:px-8 py-6">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
